module.exports = __webpack_public_path__ + "static/img/technology2.c6b9b57d.png";